import { render } from "./HeroVideo.vue?vue&type=template&id=bd974e32&scoped=true&lang=pug"
import script from "./HeroVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroVideo.vue?vue&type=script&setup=true&lang=js"

import "./HeroVideo.vue?vue&type=style&index=0&id=bd974e32&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd974e32"]])

export default __exports__